import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from './reportWebVitals';
import { Router ,Route, BrowserRouter } from 'react-router-dom';

import WordsPage from './WordsPage.js';

const Routing = () => {
  return(
    <Router>
      <Route>
        <Route exact path="/" component={App} />
        <Route path="/words" component={WordsPage} />
      </Route>
    </Router>
  )
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// </React.StrictMode>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



